const HEX = { good: "#34d399", amber: "#fbbf24", red: "#f87171", grey: "#64748b" };
const WHEELS = [90, 310];

export function SvgCar({ zones, view, selected, onSelect }) {
  const c = (k) => HEX[zones?.[k]?.status?.[view] || "grey"];
  const part = (k) => ({
    stroke: c(k), fill: c(k), fillOpacity: selected === k ? 0.35 : 0.12, strokeWidth: 2.5,
    onClick: () => onSelect(k), style: { cursor: "pointer", filter: `drop-shadow(0 0 4px ${c(k)})` }, "data-testid": `svg-zone-${k}`,
  });
  return (
    <svg viewBox="0 0 400 180" className="absolute inset-0 w-full h-full p-6" data-testid="hologram-svg">
      <path d="M20 120 L40 90 L110 82 L150 50 L260 50 L300 82 L375 92 L385 120 Z" {...part("body")} />
      <rect x="300" y="92" width="50" height="22" rx="3" {...part("engine")} />
      <rect x="265" y="98" width="30" height="16" rx="3" {...part("engine")} />
      <rect x="245" y="62" width="10" height="20" rx="2" {...part("history")} />
      <rect x="10" y="122" width="60" height="7" rx="3" {...part("running")} />
      {WHEELS.map((x) => (
        <g key={x}>
          <line x1={x} y1="88" x2={x} y2="118" {...part("suspension")} />
          <circle cx={x} cy="132" r="28" {...part("tyres")} fillOpacity={0.05} strokeWidth={9} />
          <circle cx={x} cy="132" r="14" {...part("brakes")} />
        </g>
      ))}
      <ellipse cx="200" cy="168" rx="190" ry="8" fill="none" stroke="#22d3ee" strokeOpacity="0.35" />
    </svg>
  );
}
